const Breadcrumbs = {
  parts: [
    'breadcrumbs',
    'breadcrumbLink',
    'breadcrumbText',
    'breadcrumbSeparator'
  ],
  baseStyle: {
    breadcrumbs: {
      display: 'flex',
      alignItems: 'center',
      gap: '2', // 8px
      position: 'relative',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
    },

    breadcrumbLink: {
      color: 'brandColors.greyscale80',
      fontFamily: 'aktiv-grotesk',
      fontSize: 'xs', // 12px
      fontWeight: '400',
      lineHeight: '120%',
      textDecoration: 'none',
      _hover: {
        textDecoration: 'underline',
      },
    },

    breadcrumbText: {
      color: 'brandColors.greyscale90',
      fontFamily: 'aktiv-grotesk',
      fontSize: 'xs', // 12px
      fontWeight: '500',
      lineHeight: '120%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
    },

    breadcrumbSeparator: {
      color: 'brandColors.greyscale40',
      fontFamily: 'aktiv-grotesk',
      fontSize: 'xs', // 12px
      fontWeight: '400',
      lineHeight: '120%',
      px: '0.5', // Small spacing around separator
    },
  },
};

export default Breadcrumbs;
